import store from '../store';
let is_init = true;
let array = [], num = 0;
// import Login from '@auth/index';
export default {
	data: [{
		errcode: 'AUTHORIZATION_INVALID',
		prompt: '',
		url: '',
		fun: function(res) {
            if (location.pathname =='/practice/test'){
                tools.cache.del('status');
                store.commit('GET_INFO')
                is_init = false;
                tools.ajax({
                    url: '/api/init',
                    headers: {
                        'X-ISSIGN': 1
                    },
                    isLoading: true,
                    successFun: function (res) {
                        tools.cache.set('Authorization', res.token);
                        store.state.app.dialogVisible = true;
                        store.state.app.sin_login = true;
                        is_init = true;
                    },
                    errorFun: function (error) {
                        log.error('获取签名失败');
                    },
                    type: 'GET'
            })
        }else{
            array.push(res.option);
            if (is_init) {
                tools.cache.del('Authorization');
                getToken(array);
            }
            is_init = false;
        }
			
            function getToken (array){
                tools.ajax({
                    url: '/api/init',
                    headers: {
                        'X-ISSIGN': 1
                    },
                    isLoading: true,
                    successFun: function(res) {
                        tools.cache.set('Authorization', res.token);
                        setTimeout(()=>{
                        	next(array);
                        }, 500)
                        
                    },
                    errorFun: function(error) {
                        log.error('获取签名失败');
                    },
                    type: 'GET'
                });
            };

            function next(dataArr) {
                for(let i = 0; i < dataArr.length; i++) {
                    num++;
                    tools.ajax(dataArr[i]);
                }
                if (num === dataArr.length) {
                    is_init = true;
                    array = [];
                    num = 0;
                }
            }
		}
	}, {
		errcode: 'NO LOGIN',
		prompt: '',
		url: '',
		fun: function(res) {
            array.push(res.option);
            if (is_init) {
            	tools.cache.del('status');
				store.state.app.dialogVisible = true;
				store.state.app.sin_login = true;
            }
            is_init = false;
            
            next(array);

            function next(dataArr) {
                for(let i = 0; i < dataArr.length; i++) {
                    num++;
//                  tools.ajax(dataArr[i]);
                }
                if (num === dataArr.length) {
                    is_init = true;
                    array = [];
                    num = 0;
                }
            }
			
			
		}
	}]

}


// WEBPACK FOOTER //
// ./src/auth/error_handle.js